import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import MotifRefusListPage from "./MotifRefusListPage";
import MotifRefusAddPage from "./MotifRefusAddPage";
import MotifRefusEditPage from "./MotifRefusEditPage";


const MotifRefusWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle breadcrumbs={[
                {
                  title: 'Paramètres',
                  path: '#',
                  isSeparator: false,
                  isActive: true,
                }
              ]}>Motif refus</PageTitle>
              <MotifRefusListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Motif refus', path: '/motif-refus', isSeparator: false, isActive: true },
              ]}>Création</PageTitle>
              <MotifRefusAddPage/>
            </>
          }
        />
        <Route
          path='/:motifId/modifier'
          element={
            <>
              <PageTitle breadcrumbs={[
                { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                { title: 'Motif refus', path: '/motif-refus', isSeparator: false, isActive: true },
              ]}>Modification</PageTitle>
              <MotifRefusEditPage/>
            </>
          }
        />
        <Route index element={<Navigate to='liste' />} />
      </Routes>
    </>
  )
}

export default MotifRefusWrapper
